import styled from 'styled-components'
import ClickableListItem from 'LuxKit/List/ClickableListItem'
import Caption from 'LuxKit/Typography/Caption'
import React from 'react'
import SolidLocationPinAltIcon from 'LuxKit/Icons/solid/SolidLocationPinAltIcon'
import Group from 'components/utils/Group'
import { rem } from 'polished'
import LineCalendarIcon from 'LuxKit/Icons/line/LineCalendarIcon'
import LineCalendarAltIcon from 'LuxKit/Icons/line/LineCalendarAltIcon'

const StyledClickableListItem = styled(ClickableListItem)`
  box-sizing: border-box;
  border: 1px solid ${props => props.theme.palette.neutral.default.four};
  border-radius: ${props => props.theme.borderRadius.S};
`

interface Props {
  title: string
  location: string
  date: string
  description: string
  employmentType: string
  department?: string
  href: string
  target?: string
}

function JobListItem({
  title,
  location,
  date,
  description,
  employmentType,
  ...rest
}: Props) {
  const infoItems = [
    { icon: <SolidLocationPinAltIcon size="XXS" />, text: location },
    { icon: <LineCalendarIcon size="XXS" />, text: employmentType },
    { icon: <LineCalendarAltIcon size="XXS" />, text: date },
  ]

  return (
    <StyledClickableListItem
      title={title}
      subtitle={description}
      size="large"
      role="listitem"
      subtitleLineClamp={2} // truncate after 2 lines
      titleWeight="bold"
      {...rest}
    >
      <Group direction="vertical" gap={8} style={{ minWidth: rem(160), flexShrink: 0 }}>
        {infoItems.map(({ icon, text }, index) => (
          <Group direction="horizontal" gap={4} fullWidth key={index}>
            {icon}
            <Caption variant="small" style={{ flex: 1, minWidth: 0 }}>
              {text}
            </Caption>
          </Group>
        ))}
      </Group>
    </StyledClickableListItem>
  )
}

JobListItem.displayName = 'JobListItem'

export default JobListItem
